module.exports = {"130702001":"红旗楼街道","130702002":"胜利北路街道","130702003":"五一路街道","130702004":"花园街街道","130702005":"工业路街道","130702101":"姚家庄镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130702.json
// module id = 160
// module chunks = 0